import { render, staticRenderFns } from "./editCubebox.vue?vue&type=template&id=61002cc8&scoped=true&"
import script from "./editCubebox.vue?vue&type=script&lang=js&"
export * from "./editCubebox.vue?vue&type=script&lang=js&"
import style0 from "./editCubebox.vue?vue&type=style&index=0&id=61002cc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61002cc8",
  null
  
)

export default component.exports